const unitedStatesRegions = ['us-east-1', 'us-east-2', 'us-west-1', 'us-west-2'];

export const isRegionInUnitedStates = (region: string) => unitedStatesRegions.includes(region);
